import { I18n } from '@app/i18n/strings-keys';
import { map, isEqual } from 'lodash';

export enum TRANSFER_STATUS_VALUE {
  Null = 'null',
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Canceled = 'canceled',
  Completed = 'completed',
  Void = 'void',
  Rejected = 'rejected',
}

/**
 * @deprecated Use I18n instead
 */
export enum TRANSFER_STATUS_NAME {
  New = 'New',
  Open = 'Open',
  Pending = 'Pending',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Void = 'Void',
  Rejected = 'Rejected',
  NO_STATUS = '(No Status)',
  OPEN_DRAFT = 'Open (draft)',
}

export const TRANSFER_STATUS_NAME_OPTIONS = {
  New: I18n.Status.New,
  Open: I18n.Status.Open,
  Pending: I18n.Status.Pending,
  Canceled: I18n.Status.Canceled,
  Completed: I18n.Status.Completed,
  Void: I18n.Status.Void,
  Rejected: I18n.Status.Rejected,
  NO_STATUS: I18n.Status.NoStatusBrackets,
  OPEN_DRAFT: I18n.Status.OpenDraftBrackets,
};

export enum TRANSFER_STATUS_TOTAL_NAME {
  Total = 'Total',
}

export enum TRANSFER_STATUS_TOTAL_VALUE {
  Total = 'total',
}

export const TRANSFER_STATUS_OPTIONS = [
  {
    text: I18n.Status.NoStatusBrackets,
    value: TRANSFER_STATUS_VALUE.Null,
  },
  { text: I18n.Status.New, value: TRANSFER_STATUS_VALUE.New },
  { text: I18n.Status.Open, value: TRANSFER_STATUS_VALUE.Open },
  {
    text: I18n.Status.Pending,
    value: TRANSFER_STATUS_VALUE.Pending,
  },
  {
    text: I18n.Status.Completed,
    value: TRANSFER_STATUS_VALUE.Completed,
  },
  {
    text: I18n.Status.Rejected,
    value: TRANSFER_STATUS_VALUE.Rejected,
  },
  {
    text: I18n.Status.Canceled,
    value: TRANSFER_STATUS_VALUE.Canceled,
  },
  { text: I18n.Status.Void, value: TRANSFER_STATUS_VALUE.Void },
];

export const DISPLAYED_TRANSFER_STATUS_OPTIONS = map(
  TRANSFER_STATUS_OPTIONS,
  (option) =>
    isEqual(option.value, TRANSFER_STATUS_VALUE.Null)
      ? {
          ...option,
          text: '',
        }
      : option,
);

export const TRANSFER_REQUEST_STATUS_OPTIONS = [
  { text: I18n.Status.Open, value: true },
  { text: I18n.Status.OpenDraftBrackets, value: false },
];
